// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"189":"fb550cfaa7d1b8ee","580":"7ec1a74655ffdae6"}[chunkId] + ".js";
};